(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["besha-final-cta"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('besha-buy-box')) {
    customElements.define(
      'besha-buy-box',
      class BeshaBuyBox extends HTMLElement {
        connectedCallback() {
          this.priceEl = this.querySelector('[data-besha-price]');
          this.form = this.querySelector('form');
          this.addEventListener('change', (event) => {
            if (event.target.matches('input[name="id"]')) this.select(event.target);
          });
          if (this.form) {
            this.form.addEventListener('submit', () => {
              const btn = this.form.querySelector('[type="submit"]');
              if (btn) btn.setAttribute('aria-busy', 'true');
            });
          }
          const checked = this.querySelector('input[name="id"]:checked');
          if (checked) this.select(checked);
        }
        select(input) {
          if (this.priceEl && input.dataset.price) this.priceEl.textContent = input.dataset.price;
          this.querySelectorAll('.besha-buy__option').forEach((option) => {
            option.classList.toggle('is-selected', option.contains(input));
          });
        }
      }
    );
  }
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('.besha-buy__submit[aria-busy]').forEach((b) => b.removeAttribute('aria-busy'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["besha-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('submit', (event) => {
    if (!event.target.matches('.besha-hero .besha-buy__form')) return;
    const btn = event.target.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-busy', 'true');
  });
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('.besha-hero .besha-buy__submit[aria-busy]').forEach((b) => b.removeAttribute('aria-busy'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["besha-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('besha-review-slider')) {
    customElements.define(
      'besha-review-slider',
      class BeshaReviewSlider extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.besha-reviews__track');
          this.prev = this.querySelector('[data-dir="-1"]');
          this.next = this.querySelector('[data-dir="1"]');
          this.dots = this.querySelector('.besha-reviews__dots');
          if (!this.track) return;

          [this.prev, this.next].forEach((btn) =>
            btn && btn.addEventListener('click', () => this.go(Number(btn.dataset.dir)))
          );
          this.track.addEventListener('scroll', () => {
            cancelAnimationFrame(this.raf);
            this.raf = requestAnimationFrame(() => this.update());
          }, { passive: true });
          this.track.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowRight') { e.preventDefault(); this.go(1); }
            if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(-1); }
          });
          this.ro = new ResizeObserver(() => this.build());
          this.ro.observe(this.track);
        }
        disconnectedCallback() { if (this.ro) this.ro.disconnect(); }
        pageSize() { return this.track.clientWidth; }
        pageCount() {
          const max = this.track.scrollWidth - this.track.clientWidth;
          return max <= 2 ? 1 : Math.ceil(max / this.pageSize()) + 1;
        }
        current() {
          const max = this.track.scrollWidth - this.track.clientWidth;
          if (this.track.scrollLeft >= max - 2) return this.pageCount() - 1;
          return Math.round(this.track.scrollLeft / this.pageSize());
        }
        go(dir) { this.track.scrollBy({ left: dir * this.pageSize(), behavior: 'smooth' }); }
        build() {
          const count = this.pageCount();
          this.dots.innerHTML = '';
          this.dots.hidden = count < 2;
          for (let i = 0; i < count; i++) {
            const b = document.createElement('button');
            b.type = 'button';
            b.tabIndex = -1;
            b.addEventListener('click', () => this.track.scrollTo({ left: i * this.pageSize(), behavior: 'smooth' }));
            this.dots.appendChild(b);
          }
          this.update();
        }
        update() {
          const idx = this.current();
          const max = this.track.scrollWidth - this.track.clientWidth;
          if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
          if (this.next) this.next.disabled = this.track.scrollLeft >= max - 2;
          [...this.dots.children].forEach((d, i) => d.setAttribute('aria-current', i === idx ? 'true' : 'false'));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
